<div class="envios-pendientes-panel mt-3 mb-3" *ngIf="rows.length > 0">
  <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
    <div>
      <h2 class="panel-title mb-1">Envíos pendientes</h2>
      <p class="panel-subtitle mb-0">
        Operaciones guardadas localmente que aún no se confirmaron en el servidor.
      </p>
    </div>
    <button
      type="button"
      class="btn btn-primary btn-reenviar"
      (click)="reenviarPendientes()"
      [disabled]="!isOnline || isFlushing || isRetrying || !hasRetryableRows"
    >
      <i class="bi bi-cloud-upload me-2"></i>
      {{ isFlushing || isRetrying ? 'Reenviando...' : 'Reenviar pendientes' }}
    </button>
  </div>

  <!-- Desktop: tabla fija con cabecera siempre visible -->
  <div class="envios-desktop-wrap">
    <table class="table table-sm envios-table mb-0">
      <thead>
        <tr>
          <th>Tipo</th>
          <th>Pedido / Ticket</th>
          <th>Creación</th>
          <th>Intentos</th>
          <th>Último intento</th>
          <th>Estado</th>
          <th>Último error</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td>{{ row.operationLabel }}</td>
          <td>
            <span class="d-block">Pedido: {{ row.orderNumber }}</span>
            <span class="text-muted small">Ticket: {{ row.tkt }}</span>
            <span class="text-muted small d-block" *ngIf="row.folio">Guía: {{ row.folio }}</span>
          </td>
          <td>{{ row.queuedAt | date:'dd/MM/yyyy HH:mm:ss' }}</td>
          <td>{{ row.retryCount }}</td>
          <td>
            {{ row.lastAttemptAt ? (row.lastAttemptAt | date:'dd/MM/yyyy HH:mm:ss') : '—' }}
          </td>
          <td>
            <span class="status-badge" [ngClass]="statusClass(row.status)">
              {{ statusLabels[row.status] }}
            </span>
          </td>
          <td [title]="row.lastErrorMessage || ''">
            {{ truncateError(row.lastErrorMessage) }}
          </td>
          <td>
            <div class="envios-actions">
              <button
                type="button"
                class="envios-icon-button"
                [class.envios-icon-button--retry]="isHeld(row)"
                [disabled]="row.status === 'syncing' || isActionBusy(row)"
                [title]="isHeld(row) ? 'Reanudar y reintentar' : 'Pausar envío'"
                [attr.aria-label]="isHeld(row) ? 'Reanudar y reintentar envío' : 'Pausar envío'"
                (click)="togglePaused(row)">
                <i class="bi" [ngClass]="isHeld(row) ? 'bi-arrow-clockwise' : 'bi-pause-circle'"></i>
              </button>
              <button
                type="button"
                class="envios-icon-button"
                [disabled]="!canEdit(row) || isActionBusy(row)"
                title="Editar datos guardados"
                aria-label="Editar datos guardados"
                (click)="openEditModal(row)">
                <i class="bi bi-pencil-square"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Mobile: tarjetas -->
  <div class="envios-mobile-wrap">
    <ng-container *ngIf="rows.length > 0">
      <div class="envio-card" *ngFor="let row of rows">
        <div class="d-flex justify-content-between align-items-start mb-2">
          <strong>{{ row.operationLabel }}</strong>
          <span class="status-badge" [ngClass]="statusClass(row.status)">
            {{ statusLabels[row.status] }}
          </span>
        </div>
        <p class="mb-1 small"><span class="text-muted">Pedido:</span> {{ row.orderNumber }}</p>
        <p class="mb-1 small"><span class="text-muted">Ticket:</span> {{ row.tkt }}</p>
        <p class="mb-1 small" *ngIf="row.folio"><span class="text-muted">Guía:</span> {{ row.folio }}</p>
        <p class="mb-1 small">
          <span class="text-muted">Creación:</span>
          {{ row.queuedAt | date:'dd/MM/yyyy HH:mm:ss' }}
        </p>
        <p class="mb-1 small">
          <span class="text-muted">Intentos:</span> {{ row.retryCount }}
        </p>
        <p class="mb-1 small">
          <span class="text-muted">Último intento:</span>
          {{ row.lastAttemptAt ? (row.lastAttemptAt | date:'dd/MM/yyyy HH:mm:ss') : '—' }}
        </p>
        <p class="mb-0 small" *ngIf="row.lastErrorMessage">
          <span class="text-muted">Error:</span> {{ truncateError(row.lastErrorMessage, 120) }}
        </p>
        <div class="envios-actions envios-actions--mobile">
          <button
            type="button"
            class="envios-icon-button"
            [class.envios-icon-button--retry]="isHeld(row)"
            [disabled]="row.status === 'syncing' || isActionBusy(row)"
            [attr.aria-label]="isHeld(row) ? 'Reanudar y reintentar envío' : 'Pausar envío'"
            (click)="togglePaused(row)">
            <i class="bi" [ngClass]="isHeld(row) ? 'bi-arrow-clockwise' : 'bi-pause-circle'"></i>
            <span>{{ isHeld(row) ? 'Reintentar' : 'Pausar' }}</span>
          </button>
          <button
            type="button"
            class="envios-icon-button"
            [disabled]="!canEdit(row) || isActionBusy(row)"
            aria-label="Editar datos guardados"
            (click)="openEditModal(row)">
            <i class="bi bi-pencil-square"></i>
            <span>Editar</span>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
